//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardSectionProperties from './CardSectionProperties.vue'
import ImageObjectCardSectionPropertiesDefaultSlot from './ImageObjectCardSectionPropertiesDefaultSlot.vue'
import { AXIOS } from '../../axios/axios'
import { EventBus } from '../../EventBus/EventBus'

export default {
  name: 'CardSectionPropertiesWithImage',
  components: {
    CardSectionProperties,
    ImageObjectCardSectionPropertiesDefaultSlot
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    },
    objectInitial: {
      type: Object,
      default: null
    }
  },
  data: function () {
    const data = {
      imageEditable: false,
      imageProperty: 'image',
      imageSingle: false,
      imageUrl: null,
      width: 140,
      height: 140,
      shiftedFieldsCount: 4,
      expandCardOnImageClick: false
    }
    if (this.config.componentProps) {
      Object.entries(this.config.componentProps).forEach(entry => {
        data[entry[0]] = entry[1]
      })
    }
    return data
  },
  watch: {
    objectSrc: {
      handler: function (objectSrc) {
        this.onObjectChanged(objectSrc)
      },
      immediate: true
    }
  },
  created: function () {
    this.prepareSection()
  },
  methods: {
    // @Default
    prepareSection: function () {
      if (this.config.props) {
        const marginLeft = this.width + 10

        this.config._customView = 'image'
        for (let i = 0; i < this.shiftedFieldsCount && i < this.config.props.length; i++) {
          this.config.props[i]._itemStyle = 'margin-left: ' + marginLeft + 'px;'
        }
      }
    },
    // @Default
    onObjectChanged: function (objectSrc) {
      let imageId = null
      if (objectSrc) {
        const images = objectSrc[this.imageProperty] || []
        if (images.length) {
          imageId = images[images.length - 1].id
        }
      }
      this.imageUrl = imageId ? '/service/delta/document/read?id=' + imageId : null
    },
    onUploadImage: function (e) {
      const file = e.target.files[0]
      if (file) {
        const data = new FormData()
        data.append('oid', this.objectSrc.$id)
        data.append('single', this.imageSingle ? 'true' : 'false')
        data.append('rel', '#' + this.imageProperty)
        data.append('file', file, file.name)
        AXIOS({
          method: 'post',
          url: '/service/fileobj/create',
          data: data
        }).then(result => {
          const imageData = result.data
          const images = this.imageSingle ? [] : this.objectSrc[this.imageProperty] || []
          images.push({
            id: imageData.id,
            key: imageData.key,
            type: '%fileobject%'
          })
          this.objectSrc[this.imageProperty] = images
          this.onObjectChanged(this.objectSrc)

          EventBus.$emit('image-uploaded', imageData)
        }).catch(error => {
          this.$q.notify({
            type: 'negative',
            progress: 'true',
            message: error.message,
            timeout: 8000
          })
        })
      }
    }
  }
}
